import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import featuresOverview from './../../../../assets/images/placeholder/Features-Overview.svg';
import file from './../../../../assets/images/svg/039-file.svg';
import arrowDashed from './../../../../assets/images/svg/005-arrow-down-dashed.svg';
import arrowDirect from './../../../../assets/images/svg/005-arrow-down-direct.svg';
import previewPdf from './../../../../assets/images/placeholder/pdf-placeholder.jpg';
import * as R from 'ramda';
import { updateOnBoardingStep } from '../../../../actions/user-api';
import {ConnectionTypes, AssuranceOptions, SocialNetworksOptions, PersonalServices, CommonServices } from '../../../../constants/utils/connectionTypes';

export const Step5 = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    if (R.isNil(user) || R.isNil(user.services) || user.services.length === 0) {
        return '';
    }

    return (
			<article className="view-calc pt-0 mb-auto">
				<div className="auto-view">
					<div className="container-fluid">
						<header className="rounded-bottom-left-sm rounded-top-right-sm rounded-bottom-0 mb-0 alert alert-primary text-center">
							<h1 className="text-primary font-weight-bolder mt-2 mb-2">La situation du défunt</h1>
						</header>
						<div className="card py-4 px-sm px-lg-lg shadow mb-4 rounded-top-0 rounded-bottom-sm">
							<div className="row gx-2 align-items-center">
								<div className="col-12 col-lg-auto">
									<p className="container-copy">
										Pour votre information, entre les <span className="font-weight-bolder">organismes de bases</span> et les <span className="font-weight-bolder">organismes complémentaires</span> que vous avez sélectionné.
									</p>
									<h1 className="container-narrow text-primary font-weight-bolder ls-n1">Il y a: {user.services.length} démarches à effectuer.</h1>
								</div>
								<div className="col-12 col-lg">
									<img className="block img-fluid ml-auto w-hd-75 px-4 px-hd-6" src={featuresOverview} alt="features overview" />
								</div>
							</div>
							<div className="block pt-5">
								<div className="d-flex align-items-start mt-2" role="button" data-toggle="modal" data-target="#apercuSituation">
									<img className="img-fluid h-6 mr-4" src={file} alt="file" />
									<div className="container-base flex-grow-1 my-auto">
										<h5 className="text-uppercase font-weight-bolder">Exemple: Courrier de résiliation d’abonnement mobile</h5>
										<p className="h6 lh-copy">Visualisation du document nécessaire à la résiliation du contrat de la société de téléphonie mobile.</p>
									</div>
								</div>
								<div className="grid-sm grid-sm-min grid-lg-tight mt-4">
									{R.sortWith([R.ascend(R.prop("title"))])(user.services.filter((s) => s.connectionType !== ConnectionTypes.activity)).map((s, index) => {
										let serviceOptions = [].concat(Object.values(AssuranceOptions), Object.values(SocialNetworksOptions), Object.values(PersonalServices), Object.values(CommonServices));
										let service = Object.entries(serviceOptions)
											.map((entry) => entry[1])
											.find((o) => o.connectionType === s.connectionType);
										if (R.isNil(service)) {
											return "";
										}
										return (
											<div key={index} className="d-flex align-items-start o-50">
												<img className="img-fluid h-4 mr-3" src={file} alt="file" />
												<div className="container-base flex-grow-1 my-auto">
													<p className="small lh-copy text-lowercase my-auto">{service.title}</p>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					</div>
				</div>
				<footer className="block mt-auto mb-sm text-right w-100">
					<div className="container-fluid flex-md-row align-items-center">
						<Link to="/auth/signup/step4" className="btn btn-faded px-md-gutter mr-3 ml-auto">
							Retour
						</Link>
						<Link
							to="/auth/signup/step6"
							className="btn btn-info loading-btn px-md-gutter px-4"
							onClick={() => {
								dispatch(updateOnBoardingStep(5));
							}}>
							Passer à l'étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
						</Link>
						<h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
					</div>
				</footer>
				<div className="modal fade px-0" id="apercuSituation" aria-labelledby="apercuSituationlLabel" aria-hidden="true">
					<div className="modal-dialog px-2 container-modal">
						<div className="modal-content bg-light">
							<div className="modal-header" data-dismiss="modal" aria-label="Close">
								<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
									<h5 className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1" id="apercuSituationlLabel">
										aperçu du document
									</h5>
								</div>
							</div>
							<div className="modal-body">
								<div className="grid grid-1 grid-lg-2 align-items-center">
									<div className="col-12 col-lg justify-content-around">
										<div className="card paper-shadow border-0 h-100 mx-auto container-lg-copy">
											<img className="img-fluid img-contain" src={previewPdf} width="100%" alt="pdf preview" />
										</div>
									</div>
									<div className="col-12 col-lg h-100 justify-content-around">
										<div className="card shadow-xs mt-5 rounded rounded-top-left-sm border-0">
											<div className="card-header bg-primary text-white rounded-bottom-right-sm rounded-top-left-sm text-center">
												<div className="d-flex align-items-center justify-content-center h-lg w-lg rounded-circle bg-white shadow mx-auto mb-3 mt-n6">
													<img className="img-fluid h-5 o-75" src={file} alt="file" />
												</div>
												<h2 className="h2 font-weight-bolder ls-n1">Liste des tâches à faire par vos proches au moment du décès.</h2>
											</div>
											<div className="card-body">
												<div className="grid grid-sm-2 text-center">
													<div className="col-12 col-md justify-content-around">
														<h5 className="h5 text-uppercase font-weight-bolder mb-2">Sans notre aide</h5>
														<p className="h6">Rechercher et lister tous les organismes</p>
														<img className="img-contain img-fluid o-75 py-1 h-5 mb-2" src={arrowDashed} alt="Step" />
														<p className="h6">Chercher leurs coordonnées</p>
														<img className="img-contain img-fluid o-75 py-1 h-5 mb-2" src={arrowDashed} alt="Step" />
														<p className="h6">Rédiger les courriers selon les mentions légales</p>
														<img className="img-contain img-fluid o-75 py-1 h-5 mb-2" src={arrowDashed} alt="Step" />
														<p className="h6">En faire une copie</p>
														<img className="img-contain img-fluid o-75 py-1 h-5 mb-2" src={arrowDashed} alt="Step" />
														<p className="h6 mb-0">Les poster en recommandé </p>
													</div>
													<div className="col-12 col-md justify-content-around">
														<h5 className="h5 text-uppercase font-weight-bolder mb-2">Avec notre aide</h5>
														<p className="h6 mb-auto pb-2">Se connecter</p>
														<img className="img-contain img-fluid o-75 py-1 mw-4 mx-auto" src={arrowDirect} alt="Direct" />
														<h5 className="h4 text-uppercase font-weight-bolder pt-2 mt-auto mb-0">Valider</h5>
													</div>
												</div>
											</div>
											<div className="card-footer text-center rounded">
												{/* <h2 className="h2 font-weight-bolder">Vous voulez notre aide ?</h2> */}
												<button type="button" className="btn btn-faded mr-2" data-dismiss="modal">
													Fermer
												</button>
												{/* <button type="button" className="btn btn-info" data-dismiss="modal" onClick={() => {
                                                dispatch(updateOnBoardingStep(5));
                                                history.push("/auth/signup/step6");
                                            }}>Oui</button> */}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</article>
		);
}